import React, { FC, ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";

import "./MainLayout.scss";

type TProps = {
  children: ReactNode;
};

const MainLayout: FC<TProps> = ({ children }) => {
  const location = useLocation();

  const clearModalBackdrop = () => {
    const modal = document.getElementsByClassName("modal-backdrop");
    if (modal.length) {
      modal[0].remove();
    }
  };

  useEffect(() => {
    clearModalBackdrop();
  }, [location]);

  return (
    <>
      <main className="container py-4 flex-shrink-0" id="main-layout">
        {children}
      </main>
      {/* <QBUnauthWarningModal qbUrl={qbAuthUrl} showModal={showModal} onClose={closeModal} /> */}
    </>
  );
};

export default MainLayout;
